import { render, staticRenderFns } from "./lkuCustomer.vue?vue&type=template&id=f6a63c54"
import script from "./lkuCustomer.vue?vue&type=script&lang=js"
export * from "./lkuCustomer.vue?vue&type=script&lang=js"
import style0 from "./lkuCustomer.vue?vue&type=style&index=0&id=f6a63c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports